// 多人检测提示语（函数形式，支持动态传入人数）
export const MULTIPLE_PEOPLE_MESSAGES = [
  (count) => `小提醒，画面中有${count}位人员。为保证面试顺利，请仅您本人入镜～`,
  (count) => `小提醒：检测到${count}位人员，请暂时保持只有您在镜头中哦～`,
  (count) => `小提醒，画面似乎出现${count}人，请调整为仅您本人入镜～`,
  (count) => `小提醒，检测到${count}个面部信号，请先确保只有您在镜头前～`
]

// 离开画面提示语
export const LEAVE_SCREEN_MESSAGES = [
  '小提醒，暂未检测到您入镜，方便回到镜头前吗？我在等您～',
  '小提醒：您似乎离开了镜头，请回来后我们继续～',
  '小提醒，暂未识别到您的面部，麻烦回到镜头中心哦～',
  '小提醒，如仍在面试，请回到镜头前～',
  '小提醒，您有些偏离镜头了，请回到原位置继续面试～',
]

/**
 * 从数组中随机选择一个元素
 * @param {Array} array - 数组
 * @returns {*} 随机选择的元素
 */
export function getRandomMessage(messages) {
  if (!messages || messages.length === 0) {
    return ''
  }
  const randomIndex = Math.floor(Math.random() * messages.length)
  return messages[randomIndex]
}

/**
 * 获取多人检测的随机提示语
 * @param {number} count - 检测到的人数
 * @returns {string} 随机选择的提示语
 */
export function getRandomMultiplePeopleMessage(count) {
  if (!MULTIPLE_PEOPLE_MESSAGES || MULTIPLE_PEOPLE_MESSAGES.length === 0) {
    return ''
  }
  const randomIndex = Math.floor(Math.random() * MULTIPLE_PEOPLE_MESSAGES.length)
  const messageFunction = MULTIPLE_PEOPLE_MESSAGES[randomIndex]
  return typeof messageFunction === 'function' ? messageFunction(count) : messageFunction
}

